import { render } from "./DeliveryDetail.vue?vue&type=template&id=7ca1e4a4"
import script from "./DeliveryDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryDetail.vue?vue&type=script&lang=js"
script.render = render

export default script